export enum ItemTags {
    CAKE_MESSAGE_ON_CAKE = "SUB_CATEGORY_ELIGIBLE_FOR_CAKE_PERSONALISED_MESSAGE",
}

export const DEFAULT_VALUES = {
    MAX_CHARACTERS_PER_CAKE_MESSAGE: 20,
    MAX_NUMBER_OF_CAKES_ALLOWED: 2,
    PREDEFINED_WORDS_FOR_CAKE_MESSAGE: ["Happy Birthday", "Congratulations"],
};
